import { render, staticRenderFns } from "./DisconnectOrganisationModal.vue?vue&type=template&id=58ed15b0&"
import script from "./DisconnectOrganisationModal.vue?vue&type=script&lang=js&"
export * from "./DisconnectOrganisationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports